import {create} from 'zustand';
import {RatingDetailCodeStore} from './types';

export const useRatingDetailCodeStore = create<RatingDetailCodeStore>(set => ({
	ratingDetailCode: null,
	setRatingDetailCode: params => set({ratingDetailCode: params}),
}));
